import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'

import { loadGroupMembers, deleteGroupMember, resizeGroupStack, insertMemberToGroup } from '../../actions'

export const mapStateToProps = (state) => ({
    groupStackState: state.getIn(['ui', 'groupStack']),
    members: state.getIn(['ui', 'groupStack', 'groupData', 'members']).toArray(),
})

export const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            loadGroupMembers,
            deleteGroupMember,
            resizeGroupStack,
            insertMemberToGroup,
        },
        dispatch
    )

export default (GroupStackContentComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            deleteGroupMember: PropTypes.func.isRequired,
            groupStackState: PropTypes.object.isRequired,
            insertMemberToGroup: PropTypes.func.isRequired,
            loadGroupMembers: PropTypes.func.isRequired,
            members: PropTypes.array.isRequired,
            openDialog: PropTypes.func.isRequired,
        }

        render() {
            return <GroupStackContentComponent {...this.props} />
        }
    }

    return HocConnect
}
